import React, { FunctionComponent } from 'react';
import Text, { TextSize, TextTag, TextBasicProps } from 'components/typography/text';

type Action1Pros = TextBasicProps;

const Action: FunctionComponent<Action1Pros> = (props) => {
    const { children, isDangerous } = props;

    return (
        <Text
            size={TextSize.ACTION}
            hasBreakWords={true}
            isDangerous={isDangerous}
            tag={TextTag.SPAN}
        >
            {children}
        </Text>
    );
};

export default Action;
